<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xztw7i/tc-custom/9780310297864.jpg?1726519109965" alt="This image is the cover for the book Pearls of Great Price"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Pearls of Great Price
      </h1>
      <p class="bookDescription body article font2">
        <p>Joni Eareckson Tada wants to help you become rich in faith and wealthy in hope. Some people focus on material treasures, but Joni reminds you that life’s true gems come from God—priceless pearls that are worth everything to purchase … and own.In the tradition of Diamonds in the Dust and More Precious Than Silver comes this book, Pearls of Great Price. Written by a remarkable woman who has known firsthand God’s faithfulness in the midst of indescribable difficulties, these 366 inspiring new devotions, each filled with Joni’s signature storytelling, will touch your soul like a genuine pearl—rare, beautiful, and precious.To wake up each morning is, for Joni, to need the Lord Jesus desperately and to feel his blessing. And she yearns to help you grasp this blessing for yourself. Not a day breaks when she doesn’t cling to God, asking for a fresh touch from heaven as well as a fresh view on his Word. It’s the reason for her life. It’s the reason why she writes. Pearls of Great Price so clearly depicts Joni’s passion.Allow these 366 meditations to uncover a wealth of promise, of eternal truths waiting to transform the events of your life into opportunities to catch and reflect God’s glory. Featuring Joni’s own beautiful line drawings, Pearls of Great Price will open your eyes and your heart to an abundance of blessings.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joni Eareckson Tada
      </h2>
      
      <p class="authorDescription body article"><P>Joni Eareckson Tada is&#160;founder and&#160;CEO of Joni and Friends, an organization that communicates the gospel and mobilizes the global church to evangelize, disciple, and serve people living with disability. Joni is the author of numerous bestselling books, including&#160;<I>When God Weeps</I>,&#160;<I>Diamonds in the Dust</I>,&#160;and her latest award-winning devotional,&#160;<I>A Spectacle of Glory</I>. Joni and her husband, Ken,were&#160;married&#160;in 1982. For more information on Joni and Friends, visit&#160;<a href="https://urldefense.com/v3/__http:/www.joniandfriends.org/__;!!PH0vZokp8wwQNw!iWUql_R-d7vmvVh2ELq6aCSlTlm5CSOpEZk1KJl5lKfuISjG4v-fGx2PgZZqsCz6AYTHaQ$">www.joniandfriends.org</a>.&#160;</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2a986836